/**
 * Froda API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LoanStatus = 'active' | 'repaid' | 'suspended' | 'initial';

export const LoanStatus = {
    Active: 'active' as LoanStatus,
    Repaid: 'repaid' as LoanStatus,
    Suspended: 'suspended' as LoanStatus,
    Initial: 'initial' as LoanStatus
};

